import type { PermissionSelector } from "@/hooks/usePermission";

export const canViewSchedule: PermissionSelector = (x) => x.assets.canViewSchedule;
